import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-dark-web-onetime-ad',
    templateUrl: './dark-web-onetime-ad.component.html',
    styleUrls: ['./dark-web-onetime-ad.component.scss'],
    imports: [RouterLink]
})
export class DarkWebOnetimeAdComponent {
  
  constructor(public activeModal: NgbActiveModal) { }

}
